import PropTypes from 'prop-types';

const CharacterCounter = ({ limit, count, hideError = false }) => {
  let total = limit - count;

  if (total >= 0) {
    return (
      <div className="character-limit-container">
        <p>{total.toLocaleString('en-US')} characters remaining</p>
      </div>
    );
  } else if (!hideError) {
    return (
      <div className="character-limit-container">
        <p className="character-limit-exceeded">
          <strong>{total.toLocaleString('en-US')}</strong> characters (limit exceeded)
        </p>
      </div>
    );
  } else {
    return null;
  }
};

CharacterCounter.propTypes = {
  limit: PropTypes.number,
  count: PropTypes.number,
  hideError: PropTypes.bool,
};

export default CharacterCounter;
